import { render, staticRenderFns } from "./bookingSubsidiary.vue?vue&type=template&id=4135c82b&scoped=true"
import script from "./bookingSubsidiary.vue?vue&type=script&lang=js"
export * from "./bookingSubsidiary.vue?vue&type=script&lang=js"
import style0 from "./bookingSubsidiary.vue?vue&type=style&index=0&id=4135c82b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4135c82b",
  null
  
)

export default component.exports